<template>
	<div>
		<div class="data17">
			<div class="data17Til">{{list.data.menuTitle}}</div>
			<div class="data17Cen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<!-- <div class="dataImg">
				<div class="dataImgBox">
					<img :src="item.img" class="img" :style="{
				  '--img':(index*70+item.left)+'px',
				  zIndex:index
			  }" v-for="(item,index) in lista" :key="index" @mouseenter="mouseover(index)" @mouseleave="mouseout" />
					<div class="dataImgDw" :style="{
				  '--img':(indexa*70+itema.left)+'px',
				  opacity:itema.name?1:0
			  }" >
						<div class="dataImgDwXian" v-if="itema.enTil">

						</div>
						<div class="dataImgDwWz">
							{{itema.enTil}}
						</div>
					</div>
				</div>
				<div class="csBoxRight" :style="{
				width:itema.name?'300px':'0',
				opacity:itema.name?1:0
			}">
					<div class="csBoxRightTitle">
						{{itema.title}}
					</div>
					<div class="csBoxRightTitleTwo">
						{{itema.titleTwo}}
					</div>
					<div class="csBoxRightCen">
						{{itema.cen}}
					</div>
					<div class="csBoxRightImg">
						<img :src="itema.img" v-if="itema.img" />
					</div>
				</div>
			</div> -->
			<div class="data17Img">
			<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list.data.urls" :key="index">
						<img :src="item" v-if="list.data.type==1">
						<template v-else>
							<template v-if="headerShow">
								<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
							</template>
							<template v-else>
								<video :src="item"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
			<div class="data17ImgList">
				<div class="swiper-canpin" :class="`swiper-canpin${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slide-Two" v-for="(item,index) in list.data.imgs" :key="index" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'">
							<div class="data17ImgListFor" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'">
								<img :src="item" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'" />
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="data17ImgListFor" v-for="(item,index) in spImgList" :key="index">
				<img :src="item.img" />
			</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				spImgList: [{
						img: require("@/assets/product/page6/img1.png")
					},
					{
						img: require("@/assets/product/page6/img2.png")
					},
					{
						img: require("@/assets/product/page6/img3.png")
					},
					{
						img: require("@/assets/product/page6/img4.png")
					},
				],
				activeIndex: 0,
				lista: [{
						img: require("@/assets/fgrs/A.jpg"),
						enTil:'CBI-Amber',
						title:'CBI-AMBER',
						titleTwo:'琥珀色模式',
						cen:'观测黏膜深层血管与浅层血水遮挡的出血点',
						name: '1',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/D.jpg"),
						enTil:'CBI-Indigo',
						title:'CBI-INDIGO',
						titleTwo:'靓胭脂模式',
						cen:'有效提升黏膜与血管对比度',
						name: '2',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/Q.jpg"),
						enTil:'CBI-Aquar',
						title:'CBI-AQUAR',
						titleTwo:'湖绿色模式',
						cen:'增加内镜下粘膜组织结构的可见性',
						name: '3',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/R.jpg"),
						enTil:'CBI-Regular',
						title:'CBI-REGULAR',
						titleTwo:'常规模式',
						cen:'甄别粘膜层范围，突显黏膜下血管分布',
						name: '4',
						left: 0,
					},
				],
				itema: {},
				indexa:0
			}
		},
		mounted() {
			let t = this;
			let name='.swiper-data2-banner'+this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				slidesPerView: 1,
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			let nameTwo='.swiper-canpin'+this.list.index;
			const mySwiperTwo = new this.$swiper(nameTwo, {
				// 方向
				direction: 'horizontal',
				slidesPerView: 'auto', // 每屏显示3个滑块
				slidesPerGroup: 1, // 每次滑动3个滑块
				spaceBetween: 30,
				freeMode: false,
				// 自动播放
				autoplay: false,
			});
		},
		methods: {
			mouseout() {
				this.lista.map(v => {
					v.left = 0;
				})
				this.itema = {};
				this.indexa=0;
			},
			mouseover(e) {
				console.log(e)
				this.lista.map((v, a) => {
					if (e > a) {
						v.left = 0;
					} else if (e < a) {
						v.left = 80;
					}
				})
				this.indexa=e;
				this.itema = this.lista[e]
				console.log(this.lista)
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data17 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data17Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.data17Cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;
			>div{
				white-space: pre-line;
			}
		}

		.data17Img {
			width: 100%;
			height: 600px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}

		.data17ImgList {
			display: flex;
			align-items: center;

			// overflow-x: auto;
			.swiper-canpin {
				width: 1200px;
				overflow: hidden;

				.swiper-slide-Two {
					width: 375px;
				}

				.swiper-slide-Two:not(:last-child) {
					margin-right: 31px;
				}
			}

			.data17ImgListFor:not(:last-child) {
				margin-right: 31px;
			}

			.data17ImgListFor {
				width: 375px;
				height: 230px;
				cursor: pointer;
				position: relative;

				img {
					width: 375px;
					height: 230px;
				}
			}

		}
	}

	.swiper-data2-banner {
		overflow: hidden;
		
	}

	.swiper-slide {
		position: relative;

		img {
			width: 50vw;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 50vw;
			height: 600px;
		}
	}

	.dataImg {
		display: flex;
		justify-content: space-between;
		width: 1200px;
		height: 500px;
		background: #000;
		margin-bottom: 40px;
		overflow: hidden;
		.dataImgBox {
			position: relative;
			transform-style: preserve-3d;
			transform: perspective(1000px);
			background-color: #000;
			perspective: 1000px;
			height: 500px;
			// flex: 1;
			img {
				position: absolute;
				top: 50px;
				left: var(--img);
				transform-style: preserve-3d;
				transform: perspective(1000px) rotateY(30deg) scale(0.8);
				width: 300px;
				height: 300px;
				object-fit: cover;
				transition: all .6s ease;
			}

			img:hover {
				transform: rotateY(15deg) scale(0.9);
				// z-index: 999;
			}
			.dataImgDw{
				position: absolute;
				top: 340px;
				left: var(--img);
				transition: all .6s ease;
				width: 300px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.dataImgDwXian{
					height: 50px;
					width: 2px;
					background-color: #fff;
					border-radius: 5px;
				}
				.dataImgDwWz{
					margin-top: 20px;
					color: #fff;
					white-space: nowrap;
					width: 300px;
					text-align: center;
				}
			}
		}

		.csBoxRight {
			width: 0;
			opacity: 0;
			height: 500px;
			display: flex;
			// align-items: center;
			color: #000;
			background-color: #fff;
			transition: all 0.6s ease;
			padding: 0 30px;
			flex-direction: column;

			.csBoxRightTitle {
				font-size: 42px;
				font-weight: bold;
				margin-bottom: 20px;
			}
			.csBoxRightTitleTwo{
				font-weight: bold;
				margin-bottom: 20px;
				text-align: left;
				font-size: 38px;
			}
			.csBoxRightCen {
				flex: 1;
				font-size: 18px;
			}

			.csBoxRightImg {
				width: 100%;
				margin-top: 50px;

				img {
					width: 100%;
					height: 200px;
					object-fit: cover;
				}
			}
		}
	}
</style>